import React from "react";
import { StyledButton } from "./ActionButton.styled";

export interface IActionButton {
    icon: React.ReactNode;
    value?: number;
    label?: string;
    onClick?: () => void;
    noClickable?: boolean;
}

const ActionButton = ({
    icon,
    value,
    label,
    noClickable,
    onClick,
}: IActionButton) => {
    return (
        <>
            <StyledButton onClick={onClick} noClickable={noClickable}>
                {icon}
                <span className="button-value">{value}</span>
                {label && <span className="button-label">{label}</span>}
            </StyledButton>
        </>
    );
};

export default ActionButton;
